import React from 'react'
import { GroupsView } from 'src/components/GroupsView'
import { useLazyGetSurvivorGroupsQuery } from 'src/store/APIs/survivors'

interface GroupsProps {}

export const Groups: React.FC<GroupsProps> = () => (
  <GroupsView useLazyQuery={useLazyGetSurvivorGroupsQuery} />
)
